import { Action } from '@ngrx/store';
import { activePassesReducer } from '../nested-states/active-passes/reducers';
import { expiredPassesReducer } from '../nested-states/expired-passes/reducers';
import { fromLocationPassesReducer } from '../nested-states/from-location/reducers';
import { futurePassesReducer } from '../nested-states/future-passes/reducers';
import { hallMonitorPassesReducer } from '../nested-states/hall-monitor-passes/reducers';
import { invitationsReducer } from '../nested-states/invitations/invitations.reducer';
import { requestsReducer } from '../nested-states/requests/reducers';
import { toLocationPassesReducer } from '../nested-states/to-location/reducers';
import { IPassLikeCollectionState, passLikeCollectionInitialState } from '../states/pass-like-collection.state';

export function passLikeCollectionReducer(state = passLikeCollectionInitialState, action: Action): IPassLikeCollectionState {
	return {
		invitations: invitationsReducer(state.invitations, action),
		requests: requestsReducer(state.requests, action),
		expiredPasses: expiredPassesReducer(state.expiredPasses, action),
		futurePasses: futurePassesReducer(state.futurePasses, action),
		activePasses: activePassesReducer(state.activePasses, action),
		toLocation: toLocationPassesReducer(state.toLocation, action),
		fromLocation: fromLocationPassesReducer(state.fromLocation, action),
		hallMonitorPasses: hallMonitorPassesReducer(state.hallMonitorPasses, action),
	};
}
